export const needToForceSignOff = (loggedInUser: string, lockedUser?: string): boolean => {
  /* 
  Looks at the user who was signed in from edge and determines
  if the currently locked user is the same
  */
  if (!lockedUser) {
    return false;
  } else {
    if (lockedUser === loggedInUser) {
      return false;
    }
  }
  return true;
};
